<div class="card">
  <div class="header">
    <div>
      <span>Serie </span>
      <span>{{ nfe?.serie }}</span>
    </div>
    <div class="tooltip-container">
      <span>Nº </span>
      <span>{{ nfe?.numero }}</span>
    </div>
  </div>
  <div class="body">
    <div class="prop">
      <small>CLIENTE: </small>
      <span>{{ nfe?.destinatario | formatter: "cpfCnpj" }}</span>
    </div>
    <div class="prop">
      <small>VALOR: </small>
      <span>{{ nfe?.valor | currency: "BRL" }}</span>
    </div>
    <div class="prop">
      <small>SITUAÇÃO: </small>
      <span [ngClass]="nfe?.status?.toLowerCase()">{{ nfe?.status }}</span>
    </div>
    <div class="prop" *ngIf="nfe?.status !== 'REJEITADO'; else error">
      <small>EMISSÃO: </small>
      <span>{{ nfe?.emissao }}</span>
    </div>
    <div class="info-container">
      <i
        class="pi pi-info-circle tooltip-icon"
        role="button"
        tabindex="0"
        aria-label="Exibir detalhes da nota"
        (click)="showOverlay($event)"
        (keydown.enter)="showOverlay($event)"
      ></i>

      <p-overlayPanel
        #overlay
        appendTo="body"
        [style]="{ 'min-width': '200px' }"
      >
        <div class="copy-container">
          <p><strong>ID:</strong> {{ nfe?.id }}</p>

          <button (click)="copyToClipboard(nfe?.id)">
            <i class="pi pi-copy"></i> Copiar
          </button>
        </div>
      </p-overlayPanel>
    </div>
    <ng-template #error>
      <div class="prop">
        <button (click)="showError()">
          <small [style.color]="'red'">
            <i class="pi pi-exclamation-triangle"></i>
            Ver detalhes da rejeição
          </small>
        </button>
      </div>
    </ng-template>
  </div>
  <div class="footer">
    <div class="content">
      <p-menu #menu [model]="menuOptions()" [popup]="true"></p-menu>
      <app-button
        text="Opções"
        icon="pi-bars"
        (click)="menu.toggle($event)"
        backgroundColor="var(--violet-500)"
        textAlign="flex-start"
        [fullWidth]="true"
      ></app-button>
    </div>
  </div>
</div>
